import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalanceEmailTemplate.Save.IRequest;
type Response = Api.Core.StatementBalanceEmailTemplate.Save.IResponse;
type Headers = Api.Core.StatementBalanceEmailTemplate.Save.IHeaders;
const url = '/api/Management/StatementBalanceEmailTemplate';
export default async function statementBalanceEmailTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
